import { CategoriesOrderBy, CategoriesService, CategoryPrivate, SettingsPrioCategoriesPrivate, SettingsPriocategoriesService } from "../client"

/* Interfaces */
export interface CategoriesTableProps {
    searchValue: string
    cg_update: boolean
    cg_delete: boolean
}

export interface AddCategoryProps {
    onClose: () => void
    isOpen: boolean
}

export interface DetailCategoryProps {
    onClose: () => void
    isOpen: boolean
    categoryId: string
}

export interface EditCategoryProps {
    onClose: () => void
    isOpen: boolean
    category: CategoryPrivate
}

export interface PrioCategoryBlock {
    id: string
    fk_category_id: string | null
    prio: number
}


/* Endpoints */
export const readCategories = ({
    per_page,
    page,
    order_by,
    descending,
    query,
    showInactive,
}: {
    per_page: number,
    page: number
    order_by?: CategoriesOrderBy
    descending?: boolean
    query?: string
    showInactive? : boolean
}) => {
    return {
        queryFn: async () => {
        const data = await CategoriesService.readCategories({
            skip: (page - 1) * per_page,
            limit: per_page,
            orderBy: order_by,
            descending: descending,
            showInactive: showInactive ?? true,
            query: query,
        })

        return data ?? { data: null, count: 0 }
        },
        queryKey: ["categories", { page, order_by, descending, query }],
    }
}

export const readCategoryById = (categoryId: string) => {
    return {
        queryFn: async () => {
        const data = await CategoriesService.readCategoryById({
            categoryId: categoryId
        })
        return data ?? { data: null, count: 0 }
        },
        queryKey: ["category", { categoryId }],
    }
}


export const readSettingsPrioCategories = () => {
  return {
    queryFn: async () => {
      const data = await SettingsPriocategoriesService.readSettingsPriocategories()
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["settings-priocategories"],
  }
}


/* FUNCTIONS */
export function sortBlocks(priocategories: SettingsPrioCategoriesPrivate) {
    const sorted: PrioCategoryBlock[] = [...priocategories?.data]
        .sort((a, b) => a.prio - b.prio)
        .map((item) => ({
            id: item.id,
            fk_category_id: item.fk_category?.id ?? null,
            prio: item.prio,
        }))

    return sorted
}
